import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import '@angular/localize/init';

import { CanShowByWspDirective } from './directives/can-show-by-wsp.directive';
import { DiscountLabelComponent } from './discount-label.component';

/**
 * Module declarations that are meant to be used outside of this module
 */
export const PUBLIC_DECLARATIONS = [
  DiscountLabelComponent,
  CanShowByWspDirective,
];

@NgModule({
  imports: [CommonModule],
  declarations: [PUBLIC_DECLARATIONS],
  exports: PUBLIC_DECLARATIONS,
})
export class DiscountLabelModule {}
